import Update from "./Update";

export const PermissionsUpdate = {
  contato: "update:Form-slug-contato",
  "ibgen-contato": "update:Form-slug-ibgen-contato",
  "ftec-contato": "update:Form-slug-ftec-contato",
  "ecoinove-contato": "update:Form-slug-ecoinove-contato",
  "polyuni-contato": "update:Form-slug-polyuni-contato",
  "agende-sua-visita": "update:Form-slug-agende-sua-visita",
  "agende-sua-visita-ftec": "update:Form-slug-agende-sua-visita-ftec",
  "agende-sua-visita-polyuni": "update:Form-slug-agende-sua-visita-polyuni",
  "agende-sua-visita-ibgen": "update:Form-slug-agende-sua-visita-ibgen",
  "agende-sua-visita-redhouse": "update:Form-slug-agende-sua-visita-redhouse",
  "form-cancel": "update:Form-slug-form-cancel",
  "abra-um-polo": "update:Form-slug-abra-um-polo",
  "realize-seu-evento": "update:Form-slug-realize-seu-evento",
};

export const FormsDefault = {
  Update: Update,
  PermissionsUpdate,
};
